export default __webpack_public_path__ + "static/media/Jean.5f309d74.jpg";